import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'

Vue.use(Vueaxios, axios)
export default {
  listAll (URL, header, body, success, error) {
    Vue.axios.post(URL + 'customer/v1/list/customer', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  removeCus (URL, header, body, success, error) {
    Vue.axios.post(URL + 'customer/v1/remove/customer', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  AddCus (URL, header, body, success, error) {
    Vue.axios.post(URL + 'customer/v1/add/customer', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  UpdateCus (URL, header, body, success, error) {
    Vue.axios.post(URL + 'customer/v1/update/customer', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/services/service_customer.js